module.exports = __webpack_public_path__ + "img/measure-y.3e068a99.svg";